module.exports = __webpack_public_path__ + "img/bkimg.16488ef9.png";